import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
// import lan1 from "../assets/images/lan1.png";
import lan2 from "../assets/images/lan2.png";
import lan3 from "../assets/images/lan3.png";
import lan4 from "../assets/images/lan4.png";
import lan5 from "../assets/images/lan5.png";

export default function Landing() {
  const navigate = useNavigate();
  const [expandedItems, setExpandedItems] = useState<{ [key: number]: boolean }>({});

  const toggleItem = (index: number) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <main className="main-content">
      <LandingContainer>
        {/* Landing Images */}
        <ImageContainer>
          {/* 랜딩 1 : 동영상 썸네일로 대체  */}
          {/* <LandingImage src={lan1} alt="Landing 1" /> */}

          <div
            style={{
              width: "100%",
              maxWidth: "800px",
              padding: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              aspectRatio: "16 / 9",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/1fpthFr93J4?si=7TpzWL8kHWA-v8p9"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{ width: "100%", height: "100%" }}
            ></iframe>
          </div>

          <LandingImage src={lan2} alt="Landing 2" />
          <LandingImage src={lan3} alt="Landing 3" />
          <LandingImage src={lan4} alt="Landing 4" />
          <LandingImage src={lan5} alt="Landing 5" />
        </ImageContainer>
      </LandingContainer>
    </main>
  );
}

const LandingContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`;

const LandingImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
`;
